import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { useWindowScroll, useWindowSize } from 'react-use';
import { IconButton, Icon } from '@trg/tlw-ui-component';

export function BackToTop() {
  const { y } = useWindowScroll();
  const { height } = useWindowSize();

  const isHidden = useMemo(() => height > y, [height, y]);

  const backToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <IconButton
      className={clsx(
        'tlw-size-10',
        'md:tlw-size-[50px]',
        'md:tlw-py-[9.5px]',
        'tlw-flex tlw-items-center tlw-justify-center tlw-flex-col',
        height > y && 'tlw-hidden'
      )}
      icon={null}
      type="secondary"
      size="large"
      onClick={backToTop}
    >
      <Icon
        className="-tlw-m-0.5 md:tlw-m-0 md:-tlw-mt-1"
        name="ArrowUp"
        size={24}
      />
      <svg
        className=" tlw-hidden md:tlw-block"
        width="23"
        height="10"
        viewBox="0 0 23 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.7549 5.95898H17.5811V4.58789H19.7549C20.0908 4.58789 20.3643 4.5332 20.5752 4.42383C20.7861 4.31055 20.9404 4.1543 21.0381 3.95508C21.1357 3.75586 21.1846 3.53125 21.1846 3.28125C21.1846 3.02734 21.1357 2.79102 21.0381 2.57227C20.9404 2.35352 20.7861 2.17773 20.5752 2.04492C20.3643 1.91211 20.0908 1.8457 19.7549 1.8457H18.1904V9H16.4326V0.46875H19.7549C20.4229 0.46875 20.9951 0.589844 21.4717 0.832031C21.9521 1.07031 22.3193 1.40039 22.5732 1.82227C22.8271 2.24414 22.9541 2.72656 22.9541 3.26953C22.9541 3.82031 22.8271 4.29688 22.5732 4.69922C22.3193 5.10156 21.9521 5.41211 21.4717 5.63086C20.9951 5.84961 20.4229 5.95898 19.7549 5.95898Z"
          fill="currentColor"
        />
        <path
          d="M15.1064 4.53516V4.93945C15.1064 5.58789 15.0186 6.16992 14.8428 6.68555C14.667 7.20117 14.4189 7.64062 14.0986 8.00391C13.7783 8.36328 13.3955 8.63867 12.9502 8.83008C12.5088 9.02148 12.0186 9.11719 11.4795 9.11719C10.9443 9.11719 10.4541 9.02148 10.0088 8.83008C9.56738 8.63867 9.18457 8.36328 8.86035 8.00391C8.53613 7.64062 8.28418 7.20117 8.10449 6.68555C7.92871 6.16992 7.84082 5.58789 7.84082 4.93945V4.53516C7.84082 3.88281 7.92871 3.30078 8.10449 2.78906C8.28027 2.27344 8.52832 1.83398 8.84863 1.4707C9.17285 1.10742 9.55566 0.830078 9.99707 0.638672C10.4424 0.447266 10.9326 0.351562 11.4678 0.351562C12.0068 0.351562 12.4971 0.447266 12.9385 0.638672C13.3838 0.830078 13.7666 1.10742 14.0869 1.4707C14.4111 1.83398 14.6611 2.27344 14.8369 2.78906C15.0166 3.30078 15.1064 3.88281 15.1064 4.53516ZM13.3311 4.93945V4.52344C13.3311 4.07031 13.29 3.67188 13.208 3.32812C13.126 2.98438 13.0049 2.69531 12.8447 2.46094C12.6846 2.22656 12.4893 2.05078 12.2588 1.93359C12.0283 1.8125 11.7646 1.75195 11.4678 1.75195C11.1709 1.75195 10.9072 1.8125 10.6768 1.93359C10.4502 2.05078 10.2568 2.22656 10.0967 2.46094C9.94043 2.69531 9.82129 2.98438 9.73926 3.32812C9.65723 3.67188 9.61621 4.07031 9.61621 4.52344V4.93945C9.61621 5.38867 9.65723 5.78711 9.73926 6.13477C9.82129 6.47852 9.94238 6.76953 10.1025 7.00781C10.2627 7.24219 10.458 7.41992 10.6885 7.54102C10.9189 7.66211 11.1826 7.72266 11.4795 7.72266C11.7764 7.72266 12.04 7.66211 12.2705 7.54102C12.501 7.41992 12.6943 7.24219 12.8506 7.00781C13.0068 6.76953 13.126 6.47852 13.208 6.13477C13.29 5.78711 13.3311 5.38867 13.3311 4.93945Z"
          fill="currentColor"
        />
        <path
          d="M4.57617 0.46875V9H2.82422V0.46875H4.57617ZM7.20117 0.46875V1.8457H0.240234V0.46875H7.20117Z"
          fill="currentColor"
        />
      </svg>
    </IconButton>
  );
}
